import styled from '@mui/system/styled';

export const BreadCrumbsCnt = styled('div')({
  display: 'flex',
  alignItems: 'center',
  margin: '0 0 24px 0',
  gap: 8,
  padding: '0px 0px 16px 0',
  borderBottom: '1px solid #f1f5f9',

  '.heading': {
    fontSize: 16,
    fontWeight: 600,
    color: 'rgba(97, 97, 97, 1)',
    lineHeight: '32px',
    ':hover': {
      color: '#3b82f6',
      cursor: 'pointer',
    },
  },

  '.arrowIcon': {
    fontSize: 18,
    color: '#94a3b8',
    margin: '0 8px',
  },

  '.folderNameCnt': {
    display: 'flex',
    alignItems: 'center',
    gap: 8,

    '.folderName': {
      fontSize: 18,
      fontWeight: 800,
      color: 'rgba(97, 97, 97, 1)',
      ':hover': {
        color: '#3b82f6',
        cursor: 'pointer',
      },
    },
  },
});
